import { Copy, ImagePlus, X } from "lucide-react";
import { toast } from "sonner";
import { compressImage, copyText } from "@/lib/api";

const Row = ({ label, value, testid }) => (
  <div className="flex items-center gap-3 p-3 rounded-xl bg-[#120E0E] border border-[#2E2323]">
    <div className="flex-1 min-w-0">
      <p className="text-[10px] uppercase tracking-widest text-[#A89F91]">{label}</p>
      <p className="text-sm font-semibold text-amber-50 break-all" data-testid={`${testid}-value`}>{value}</p>
    </div>
    <button type="button" data-testid={`${testid}-copy-btn`}
      onClick={async () => { await copyText(value); toast.success(`${label} copiado`); }}
      className="shrink-0 inline-flex items-center gap-1 px-3 py-2 rounded-full bg-amber-500 text-[#120E0E] text-xs font-bold active:scale-95 transition-transform">
      <Copy className="w-3.5 h-3.5" /> Copiar
    </button>
  </div>
);

export const TransferInfo = ({ settings, receipt, setReceipt }) => {
  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setReceipt(await compressImage(f, 1200, 0.7));
  };
  return (
    <div className="space-y-2" data-testid="transfer-info">
      {settings.alias && <Row label="Alias" value={settings.alias} testid="transfer-alias" />}
      {settings.cbu && <Row label="CBU / CVU" value={settings.cbu} testid="transfer-cbu" />}
      {settings.holder && <p className="text-xs text-[#A89F91] px-1" data-testid="transfer-holder">Titular: <b className="text-amber-100">{settings.holder}</b></p>}
      <div className="pt-2">
        <p className="text-xs text-[#A89F91] mb-2">Comprobante de pago <span className="text-red-400">*</span></p>
        {receipt ? (
          <div className="relative w-32">
            <img src={receipt} alt="Comprobante" className="w-32 h-40 object-cover rounded-xl border border-[#2E2323]" data-testid="receipt-preview" />
            <button type="button" onClick={() => setReceipt("")} className="absolute -top-2 -right-2 bg-[#DC2626] rounded-full p-1" data-testid="receipt-remove-btn"><X className="w-3 h-3" /></button>
          </div>
        ) : (
          <label className="flex items-center justify-center gap-2 py-6 rounded-xl border-2 border-dashed border-[#4a3838] text-sm text-[#A89F91] cursor-pointer hover:border-amber-500 transition-colors">
            <ImagePlus className="w-5 h-5" /> Adjuntar foto del comprobante
            <input type="file" accept="image/*" className="hidden" onChange={onFile} data-testid="receipt-input" />
          </label>
        )}
        <p className="text-[11px] text-amber-400/80 mt-2">Al abrirse WhatsApp, recordá adjuntar esta misma foto en el chat del local.</p>
      </div>
    </div>
  );
};
